import { render, staticRenderFns } from "./e-board.vue?vue&type=template&id=ceba1ef6"
import script from "./e-board.vue?vue&type=script&lang=js"
export * from "./e-board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./e-board/locale/eboard-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fthe-exchange%2Fnews-disclosures%2Fe-board.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./e-board/locale/eboard-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fthe-exchange%2Fnews-disclosures%2Fe-board.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,FauxTabs: require('/vercel/path0/components/FauxTabs.vue').default,FloatingModal: require('/vercel/path0/components/FloatingModal.vue').default,EboardNotificationForm: require('/vercel/path0/components/forms/EboardNotificationForm.vue').default})
